import { Link } from "react-router-dom";
import { ArrowUpRight, Car, Plane, Briefcase, Shield, Building2, Sparkles, Map } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { Reveal, SectionHead } from "./Reveal";

const ICONS = [Car, Plane, Briefcase, Shield, Building2, Sparkles, Map];

export const Services = () => {
  const { t } = useI18n();
  const items = t("services.items");
  return (
    <section id="services" className="bg-[#0D0E11] border-y border-white/5">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-28 lg:py-36">
        <SectionHead eyebrow={t("services.eyebrow")} title={t("services.title")} />
        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {items.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={s.title} delay={i * 0.06}>
                <Link to="/request" data-testid={`service-card-${i}`}
                  className="group flex flex-col justify-between h-full min-h-[240px] bg-[#0B0C0E] p-8 lg:p-10 hover:bg-[#121418] transition-colors duration-500">
                  <div className="flex items-start justify-between">
                    <Icon size={22} strokeWidth={1.2} className="text-[var(--elt-gold)]" />
                    <ArrowUpRight size={16} className="text-[var(--elt-muted)] opacity-0 group-hover:opacity-100 -translate-x-1 translate-y-1 group-hover:translate-x-0 group-hover:translate-y-0 transition-all duration-400" />
                  </div>
                  <div className="mt-10">
                    <h3 className="text-xs tracking-[0.3em] uppercase text-[var(--elt-ivory)] mb-3">{s.title}</h3>
                    <p className="text-sm font-light text-[var(--elt-muted)] leading-relaxed">{s.body}</p>
                  </div>
                </Link>
              </Reveal>
            );
          })}
          <Reveal delay={0.42}>
            <Link to="/request" data-testid="service-card-cta"
              className="group flex flex-col items-start justify-end h-full min-h-[240px] bg-[var(--elt-gold)] p-8 lg:p-10">
              <span className="font-serif-elt italic text-2xl text-[#0B0C0E] leading-tight">{t("footer.signature")}</span>
              <span className="mt-4 text-[0.65rem] tracking-[0.3em] uppercase text-[#0B0C0E] flex items-center gap-2">{t("cta.request")} <ArrowUpRight size={14} /></span>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
